import AuthService from '../../services/AuthService';

export default {
    namespaced: true,
    state: {
        user: null,
        lastSeen: null,
        token: localStorage.getItem('token') || null,
    },
    getters: {
        isAuthenticated: state => !!state.token,
        user: state => state.user,
        lastSeen: state => state.lastSeen,
    },
    actions: {
        async login({ commit, dispatch }, { username, password }) {
            try {
                const payload = await AuthService.login({ username, password });

                window.localStorage.setItem('token', payload.access_token);
                window.localStorage.setItem('refresh_token', payload.refresh_token);
                window.localStorage.setItem('expires_in', payload.expires_in);

                commit('setLogin', payload.access_token);
                commit('updateLastSeen');
                dispatch('getSelf');

                return payload;
            } catch (error) {
                commit('setLogin', null);
                throw Error(error.message);
            }
        },
        async refreshToken({ commit, dispatch }) {
            try {
                const refreshToken = window.localStorage.getItem('refresh_token');

                if (!refreshToken) {
                    throw Error('Udløbet...');
                }

                const payload = await AuthService.refreshToken(refreshToken);

                window.localStorage.setItem('token', payload.access_token);
                window.localStorage.setItem('refresh_token', payload.refresh_token);
                window.localStorage.setItem('expires_in', window.moment().add(30, 'seconds').toLocaleString());
                window.localStorage.setItem('expires_in', payload.expires_in);

                commit('setLogin', payload.access_token);
                commit('updateLastSeen');
                dispatch('getSelf');

                return payload;
            } catch (error) {
                commit('setLogin', null);
                throw Error(error.message);
            }
        },
        async getSelf({ commit, dispatch, getters }) {
            // Automatic kick after X seconds
            let maxDiff = parseInt(localStorage.getItem('expires_in'), 10);
            if (!!maxDiff === false) {
                maxDiff = 1800; // 30 minutter
            }

            setInterval(() => {
                const now = window.moment();
                const lastSeen = window.moment(getters.lastSeen);
                const diffBetweenNowAndLastSeen = now.diff(lastSeen, 'seconds');

                if (diffBetweenNowAndLastSeen >= maxDiff) {
                    dispatch('logout', true);
                }
            }, maxDiff * 1000);

            // Get self user
            try {
                const user = await AuthService.getSelf();
                commit('setUser', user);
                commit('updateLastSeen');
                return user;
            } catch (error) {
                commit('setUser', null);
                throw Error(error.message || '');
            }
        },
        updateLastSeen({ commit }) {
            commit('updateLastSeen');
        },
        logout({ commit }, reset = false) {
            commit('setLogin', null);
            commit('setUser', null);
            window.localStorage.removeItem('token');
            window.localStorage.removeItem('expires_in');
            window.localStorage.removeItem('refresh_token');

            if (reset) {
                window.location.href = '/';
            }
        },
    },
    mutations: {
        setLogin(state, token = null) {
            state.token = token;
        },
        setUser(state, user = null) {
            state.user = user;
        },
        updateLastSeen(state) {
            state.lastSeen = window.moment();
        },
    },
};
